module.exports = __webpack_public_path__ + "static/media/insurance_landing_hero.9491163c.svg";